import React from 'react';
import { FormattedEvent } from '../../../types';
import EventItem from '../EventItem/EventItem';
import { formatDateForDayColumn } from '../../../functions/date';
import './DayColumn.css'

interface DayColumnProps {
  date: Date;
  events: FormattedEvent[];
  isEmptyWeek?: boolean;
}

const DayColumn: React.FC<DayColumnProps> = ({ date, events, isEmptyWeek }) => {
  const isToday = date.toDateString() === new Date().toDateString();
  const isPast = date < new Date(new Date().setHours(0, 0, 0, 0));

  const classNames = [
    "day-column",
    events.length === 0 ? "no-events" : "",
    isPast ? "past-day" : "",
    isToday ? "today" : "",
    isEmptyWeek ? "empty-week" : ""
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div className={classNames}>
      <div className="day-column-header">
        <h4>{formatDateForDayColumn(date)}</h4>
      </div>
      <div className="events">
        {events.length > 0 ? (
          events
          .sort((a, b) => new Date(a.start).getTime() - new Date(b.start).getTime())
          .map((event) => <EventItem key={event.id} event={event} />)
        ) : !isEmptyWeek ? (
          <p>
            <i>Heute keine Termine</i>
          </p>
        ) : null}
      </div>
    </div>
  );
};
export default DayColumn;